<template>
  <button style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlRegisterUser" id="btnOpenRegisterUser">
    Open
  </button>
  <div class="modal fade" id="mdlRegisterUser" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New user</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <label for="txtNameClient" class="form-label">Name</label>
              <input type="text" class="form-control" id="txtNameClient" v-model="user.Name" required />
              <div class="invalid-feedback">Please enter your Name.</div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="txtEmail" class="form-label">Email</label>

              <input type="text" class="form-control" id="txtEmail" v-model="user.Username" required />
              <div class="invalid-feedback">Please enter an Email.</div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="txtPhone" class="form-label">Direct phone number</label>

              <input type="text" class="form-control" id="txtPhone" v-model="user.Contact" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="txtRole" class="form-label">Role</label>

              <input type="text" class="form-control" id="txtRole" v-model="user.Role" />
            </div>
          </div>

          <div class="row mt-3" v-if="!isUser">
            <div class="ml-5">
              <input class="form-check-input" type="checkbox" value="" id="chkMail" v-model="user.SendMail" />
              <label class="form-check-label ml-5" for="chkMail" style="margin-left: 10px">
                Send mail
              </label>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <ul class="no-bullets">
                <li v-if="error.incomplete == true" class="text-danger">Enter the requested information</li>
                <li v-if="error.already == true" class="text-danger">The mail {{ user.Username }} is already registered
                </li>
                <li v-if="error.badMail == true" class="text-danger">The mail is in the wrong format</li>
              </ul>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <button type="button" class="btn btn-primary w-100" @click="register">
                <i class="bi bi-save"></i> Save
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeMdlRegisterUser">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "new-user",
  props: ["idClient", "rol"],
  data: function () {
    return {
      error: { incomplete: false, already: false, badMail: false },
      user: {
        Name: "",
        Username: "",
        Password: "",
        RepeatPassword: "",
        Contact: "",
        Role: "",
        IdClient: 0,
        SendMail: true,
      },
    };
  },
  components: {},
  methods: {
    newUser() {
      document.getElementById("btnOpenRegisterUser").click();
    },
    register() {
      if (this.novalid()) return false;

      let self = this;
      this.user.IdClient = this.idClient;
      this.$vtc
        .vtcFetch("/Auth/RegisterBasic", this.user, 'API2')
        .then(function (data) {
          if (data == true) {
            document.getElementById("closeMdlRegisterUser").click();
            self.resetUser();
            self.$emit('userCreated');
          }
        }).catch(function (e) {
          console.log("ERROR -> ", e);
          if (e.codigo == 102) self.error.already = true;
        });
    },
    resetUser() {
      this.user.Name = "";
      this.user.Username = "";
      this.user.Password = "";
      this.user.RepeatPassword = "";
      this.user.Contact = "";
      this.user.Role = "";
      this.user.IdClient = 0;
      this.user.SendMail = true;
    },
    novalid() {
      this.error.incomplete = false;
      this.error.badMail = false;

      if (this.user.Name == "") { this.error.incomplete = true; }
      if (this.user.Contact == "") { this.error.incomplete = true; }
      if (this.user.Role == "") { this.error.incomplete = true; }
      if (this.user.Username == "") { this.error.incomplete = true; }
      if (this.user.Username != "" && !this.isValidEmailAddress(this.user.Username)) this.error.badMail = true;

      return (this.error.incomplete || this.error.badMail);
    },
    open() {
      document.getElementById("btnOpenRegisterUser").click();
    },
    isValidEmailAddress(mail) {
      var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
      return pattern.test(mail);
    }
  },
  computed: {
    isUser() {
      return this.rol.includes("user")
    }

  },
  mounted() {

  },
};
</script>
<style></style>